import { gql } from '@apollo/client';

/**
 * Spec 0016 (дипломы студентов) — ERP-scope queries. Operation names are
 * deliberately different from the backend field names (`groupDiplomas`,
 * `diplomaDownloadUrl`) to avoid the codegen result-type collapse.
 */

/**
 * One row per student of the group, each carrying the PL and EN diploma slots
 * (either may be `null` — that is the "not attached yet" state).
 */
export const GroupDiplomasQuery = gql`
  query ErpGroupDiplomas($groupId: ID!) {
    groupDiplomas(groupId: $groupId) {
      agreementTitle
      # ТЗ 0111 (#138): оценка препода за занятие «Дипломный проект» из LMS.
      graduationProjectMark
      hasGraduationProjectLesson
      student {
        id
        firstName
        lastName
        fullName
        email
      }
      pl {
        id
        pk
        language
        source
        originalName
        contentType
        sizeBytes
        version
        uploadedAt
        uploadedByName
      }
      en {
        id
        pk
        language
        source
        originalName
        contentType
        sizeBytes
        version
        uploadedAt
        uploadedByName
      }
    }
  }
`;

/**
 * Mints a short-lived download link for a single diploma. Deliberately fetched
 * per click (never prefetched into the list): the URL expires, so a link minted
 * while rendering the table would already be stale by the time it is used.
 */
export const DiplomaDownloadUrlQuery = gql`
  query ErpDiplomaDownloadUrl($diplomaId: ID!) {
    diplomaDownloadUrl(diplomaId: $diplomaId) {
      url
      expiresAt
    }
  }
`;
